import { render } from "./PedigreeView.vue?vue&type=template&id=3d2e980e"
import script from "./PedigreeView.vue?vue&type=script&lang=js"
export * from "./PedigreeView.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/fife-cz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__